<template>
    <v-autocomplete
        :loading="loading"
        :items="items"
        clearable
        @click:clear="resetError"
        :autofocus="autofocus"
        append-outer-icon=""
        :search-input.sync="search"
        @keypress.enter="fetchData"
        @keydown.ctrl.enter.prevent="fetchData"
        :item-text="type == 'account' || type == 'customer' ? 'displayName' : 'name'"
        item-value="id"
        :label="label"
        cache-items
        :hide-no-data="hideNoData"
        :rules="rules"
        @blur="blur"
        :error="error"
        :error-messages="errorMessage"
        @change="resetError"
        @keydown="resetError"
        @keydown.tab="select"
        dense
        hide-selected
        :outlined="outlined"
        :background-color="backgroundColor"
        v-model="id"
        :hide-details="hideDetails">
        <template v-slot:no-data>
            <v-list-item>
                <label>{{ $t('search_msg') }}</label>
            </v-list-item>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'AutoCompleteSearch',
    components: {},
    props: {
        // id: {
        //     type: Number,
        //     required: true
        // },
        items: {
            type: Array,
            required: true
        },
        autofocus: Boolean,
        label: String,
        // loading: Boolean,
        idItem: Number,
        value: Number,
        type: String,
        error: Boolean,
        errorMessage: String,
        rules: Array,
        hideNoData: { 
            type: Boolean,
            default: true
        }, 
        hideDetails: { 
            type: [Boolean, String],
            default: true
        },
        outlined: Boolean,
        backgroundColor: String,
        dense: Boolean
    },
    data() {
        return {
            search: '',
            loading: false
        }
    },
    computed: {
        id: {
            get() {
                return this.value;
            },
            set(val) {
              this.$emit('input', val);  
            }
        },
        filterData(item, queryText, itemText) {
            return itemText.toLocaleLowerCase().startsWith(queryText.toLocaleLowerCase())
        }
    },
    watch:{
        items: {
            handler() {
                this.loading = false;
            },
            deep: true
        }
    },
    methods: {
        fetchData() {
            this.loading = true;
            this.$emit('update:search-input', this.search);
           
        },
        blur() {
            this.$emit('blur');
        },
        select() {
            this.$emit('keypress:tab');
        },
        resetError() {
            this.$emit('resetError');
        }
    }
}
</script>

<style>

</style>